import { render, staticRenderFns } from "./resourceBilling.vue?vue&type=template&id=bfe9d78a"
import script from "./resourceBilling.vue?vue&type=script&lang=js"
export * from "./resourceBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports